module.exports = __webpack_public_path__ + "static/media/15.2cb45283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/15.svg
// module id = 2806
// module chunks = 3